import { PropsWithChildren, useCallback } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { FilterQueryContextProvider } from 'src/contexts/FilterQueryContext';
import { ReportMetricsContextProviderV2 } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';
import { ReportConfigV2 } from 'src/hooks/reportConfigs';
import { EmptyReportV2CostOfGoodsSoldQuery } from 'src/utils/eventQueryUtils';
import {
  ReportV2Client,
  UIReportV2CostOfGoodsSoldQuery,
} from 'src/WebApiController';

export function ReportsCostOfGoodsSoldContextProviderV2({
  reportConfig,
  isExport,
  children,
}: PropsWithChildren<{
  reportConfig: ReportConfigV2;
  isExport?: boolean;
}>) {
  const { activeAccountWebClientConfig } = useAppContext();

  const getReportMetrics = useCallback(
    (
      tempReportConfig: ReportConfigV2,
      filters: UIReportV2CostOfGoodsSoldQuery,
      pageNumber: number
    ) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getCostOfGoodsSoldReportMetrics({
        ...tempReportConfig.request,
        pageNumber,
        filters,
      });
    },
    [activeAccountWebClientConfig]
  );

  const getReportMetricsSummary = useCallback(
    (
      tempReportConfig: ReportConfigV2,
      filters: UIReportV2CostOfGoodsSoldQuery
    ) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getCostOfGoodsSoldReportSummary({
        ...tempReportConfig.request,
        filters,
      });
    },
    [activeAccountWebClientConfig]
  );

  return (
    <FilterQueryContextProvider<UIReportV2CostOfGoodsSoldQuery>
      initialQuery={
        reportConfig.request.filters as UIReportV2CostOfGoodsSoldQuery
      }
      emptyQuery={EmptyReportV2CostOfGoodsSoldQuery}
      loadQueryFromUrl={false}
    >
      <ReportMetricsContextProviderV2<UIReportV2CostOfGoodsSoldQuery>
        queryKey="getReportCostOfGoodsSoldMetricsV2"
        getReportMetrics={getReportMetrics}
        getReportMetricsSummary={getReportMetricsSummary}
        disabled={isExport}
        reportConfig={reportConfig}
      >
        {children}
      </ReportMetricsContextProviderV2>
    </FilterQueryContextProvider>
  );
}
